import { canEditField, type Me } from '@salescore/client-common'
import type { ReferenceTo } from '@salescore/core'
import { isNotNullish } from 'effect/Predicate'

export function getUserColumnNameFromReferenceTo(referenceTo: ReferenceTo[]): string | undefined {
  const columnNames = referenceTo.map((r) => getUserColumnName(r.modelName)).filter(isNotNullish)
  if (columnNames.length > 0) {
    return columnNames[0]
  }
  return undefined
}

function getUserColumnName(modelName: string): string | undefined {
  // eslint-disable-next-line sonarjs/todo-tag
  // TODO: property側でユーザー参照かどうかを持ちたい
  switch (modelName) {
    case 'salesforce_user': {
      return 'salesforce_user_id'
    }
    case 'hubspot_owners': {
      return 'hubspot_owner_id'
    }
    case 'hubspot_users': {
      return 'hubspot_user_id'
    }
  }

  return undefined
}

// 個社対応の跡であり、契約終了後に削除する
export function getCanEditField(me: Me): boolean {
  return canEditField(me)
}
